import { breakpointsTailwind, useBreakpoints, useMediaQuery } from '@vueuse/core'
import { computed } from 'vue'

// { "sm": 640, "md": 768, "lg": 1024, "xl": 1280, "2xl": 1536 }
export function useBasicLayout() {
  const breakpoints = useBreakpoints(breakpointsTailwind)

  // Viewport-based helpers
  const isMobile = breakpoints.smaller('lg') // < 1024px
  const isLgToXl = breakpoints.between('lg', 'lg') // 1024px <= width < 1280px
  const isDesktop = breakpoints.greater('xl') // >= 1280px

  // Input modality (touch) - helps distinguish iPad/tablet from desktop at same width
  const isTouch = useMediaQuery('(hover: none) and (pointer: coarse)')

  // Detect iPad reliably (including iPad Pro)
  const isIPad = computed(() => {
    const ua = navigator.userAgent

    // Check for Apple touch devices
    const isAppleTouch
      = /iPad|iPhone|iPod/.test(ua)
      || (/Macintosh/.test(ua) && 'ontouchstart' in window)

    // Check if screen size is tablet-sized (>= 768px on smallest dimension)
    const isTabletSize
      = Math.min(window.screen.width, window.screen.height) >= 768

    return isAppleTouch && isTabletSize
  })

  // Treat "tablet" as touch devices in the large breakpoint band (iPad-ish widths)
  // OR specifically detected iPad
  const isTablet = computed(() => isIPad.value || (isTouch.value && isLgToXl.value))

  return { isMobile, isTablet, isDesktop, isTouch, isIPad }
}
